export enum Registrars {
    NAMERIDER = "Namerider",
}
